import React from 'react'
import CommonGrid from '../../CommonCompo/CommonGrid/CommonGrid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useFieldSchemeIssueType } from '../../../Hooks/Features/TaskLayout/Fields/useFieldSchemeIssueType'
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'
import _ from "underscore"
import CommanDialog from '../../CommonCompo/CommanDialog/CommanDialog'
import { renderField } from '../../../utils/Helper'

const FieldSchemeIssueType = ({ filterValues, setFilterValues }) => {

    const { columns, rowData, loader, options, create, setCreate, upsertIssueTypeMapping, handleIssueTypeFilter, formFields, handleChange } = useFieldSchemeIssueType({ filterValues, setFilterValues })

    return (
        <div>
            <div className='d-flex justify-content-between gap-1 mb-2 border-bottom ms-2'>
                <div className='d-flex gap-2 align-items-center'>
                    <button className='sk-btn sk-btn-primary' onClick={() => setFilterValues((prev) => ({ ...prev, scheme: {}, apiCall: true }))}><FontAwesomeIcon icon="fa-solid fa-angle-left" /></button>
                    <div className='fw-bold'>Scheme Audit: {filterValues?.scheme?.field_configuration_scheme_name}</div>
                </div>
                <div className='d-flex gap-2'>
                    <button className='sk-btn sk-btn-primary bg-black text-white' onClick={() => { setCreate((prev) => ({ ...prev, visible: true })); handleIssueTypeFilter(rowData?.[0]?.children); }}><FontAwesomeIcon icon="fa-solid fa-plus" /> Associate Mapping</button>
                </div>
            </div>
            <div style={{ height: "calc(100vh - 150px)", overflow: "auto" }}>
                <CommonGrid columns={columns} data={rowData} headerHeight={40} rowHeight={35} loader={loader?.grid} strippedTable={true} />
            </div>

            <Dialog className='modal-medium' visible={create?.visible} onHide={() => setCreate((prev) => ({ ...prev, visible: false, issueType: {}, fieldConfig: {}, editData: {}, isDelete: false }))} header="Associate issue type" draggable={false}>
                <div>
                    <div className='row'>
                        {formFields?.map((item, index) => (
                            renderField(item, index, (e, is_edit) => { handleChange(item, e) }, create, {}, {}, () => { }, () => { })
                        ))}
                    </div>
                    <div className='d-flex gap-1 justify-content-end mt-2'>
                        <button className='sk-btn sk-btn-primary' onClick={() => setCreate((prev) => ({ ...prev, visible: false, issueType: {}, fieldConfig: {}, editData: {}, isDelete: false }))}>Cancel</button>
                        {loader?.btn ? <button className="sk-btn sk-btn-primary bg-black text-white" style={{ width: "105px" }}>
                            <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button>
                            : <button className='sk-btn sk-btn-primary bg-black text-white' onClick={() => upsertIssueTypeMapping()}>Save Mapping</button>
                        }
                    </div>
                </div>
            </Dialog>

            <CommanDialog visible={create?.isDelete} handleClose={() => setCreate((prev) => ({ ...prev, isDelete: false, editData: {} }))} handleFun={() => upsertIssueTypeMapping()} message="Are you sure you want to delete this issue type mapping?" />
        </div>
    )
}

export default FieldSchemeIssueType